export const BODY_FEELING_SCALE = "low_is_good_v2";

// Unmarked historical snapshots used the opposite direction. Never mutate them.
export function bodyFeelingValue(feedback) {
  if (feedback?.body_feeling == null) return null;
  const value = Number(feedback.body_feeling);
  return feedback.body_feeling_scale === BODY_FEELING_SCALE ? value : 6 - value;
}

export function bodyFeelingText(feedback, t) {
  const value = bodyFeelingValue(feedback);
  return value == null ? "–" : `${value}/5 · ${t(`bodyFeelingMeaning_${value}`)}`;
}
